export const styles = theme => ({
  topbar: {
    position: "fixed",
    width: "100%",
    top: 0,
    left: 0,
    right: "auto",
    backgroundColor: theme.palette.background.mainDark,
    transition: theme.transitions.create(["padding", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  rightSidebar: {
    margin: theme.spacing(1)
  },
  helpButton: {
    backgroundColor: theme.palette.common.white,
    position: "fixed",
    top: "180px",
    right: "0px",
    borderRadius: "8px 0 0 8px",
    border: `1px solid ${theme.palette.primary.main}`,
    textAlign: "center"
  },
  bugButton: {
    backgroundColor: theme.palette.common.white,
    position: "fixed",
    right: "0px",
    top: "240px",
    borderRadius: "8px 0 0 8px",
    border: `1px solid ${theme.palette.primary.main}`,
    textAlign: "center"
  },
  bugTextField: {
    width: "100%"
  },
  leftTopbarShift: {
    // marginLeft: "271px",
    paddingLeft: "271px",
    // width: "calc(-271px + 100vw)"
    width: "100%"
  },
  rightTopbarShift: {
    marginRight: "271px"
    // width: "calc(-271px + 100vw)"
  },
  leftRightTopbarShift: {
    // marginRight: "271px",
    // width: "calc(-542px + 100vw)"
    paddingRight: "271px"
  },
  drawerPaper: {
    zIndex: 2200, // chat is 2000 and 2100
    width: "271px",
    backgroundColor: theme.palette.background.mainLight,
    borderRight: `1px solid ${theme.palette.background.mainLight}`, // changed from white, because we applied dark navigation on VH
    flexDirection: "inherit"
  },
  sidebar: {
    width: "270px"
  },
  content: {
    /* ...theme.mixins.gutters(), */
    paddingLeft: 40,
    paddingRight: 40,
    paddingTop: theme.spacing(17),
    paddingBottom: theme.spacing(2),
    position: "relative",
    // margin-top: 0;
    // padding-top: 90px;
    marginTop: 0,
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  leftContentShift: {
    marginLeft: "270px"
  },
  rightContentShift: {
    marginRight: "270px"
  },
  progressWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center" /* Centering y-axis */,
    alignItems: "center",
    minHeight: "calc(100vh - 217px);"
  }
});
